/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../clients/axios.ts";
import type { RequestConfig, ResponseErrorConfig } from "../../../clients/axios.ts";
import type { PostApiFilesPresignedUrlMutationRequest, PostApiFilesPresignedUrlMutationResponse, PostApiFilesPresignedUrl400, PostApiFilesPresignedUrl401, PostApiFilesPresignedUrl403, PostApiFilesPresignedUrl500 } from "../../types/PostApiFilesPresignedUrl.ts";
import { postApiFilesPresignedUrlMutationResponseSchema, postApiFilesPresignedUrlMutationRequestSchema } from "../../zod/FilesSchemas/postApiFilesPresignedUrlSchema.ts";

function getPostApiFilesPresignedUrlUrl() {
  const res = { method: 'POST', url: `/api/files/presigned-url` as const }  
  return res
}

/**
 * @summary Сгенерировать подписанный url на загрузку файла
 * {@link /api/files/presigned-url}
 */
export async function postApiFilesPresignedUrl({ data }: { data?: PostApiFilesPresignedUrlMutationRequest }, config: Partial<RequestConfig<PostApiFilesPresignedUrlMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = postApiFilesPresignedUrlMutationRequestSchema.parse(data)  
  
  const res = await request<PostApiFilesPresignedUrlMutationResponse, ResponseErrorConfig<PostApiFilesPresignedUrl400 | PostApiFilesPresignedUrl401 | PostApiFilesPresignedUrl403 | PostApiFilesPresignedUrl500>, PostApiFilesPresignedUrlMutationRequest>({ method : "POST", url : getPostApiFilesPresignedUrlUrl().url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/*+json', ...requestConfig.headers } })  
  return postApiFilesPresignedUrlMutationResponseSchema.parse(res.data)
}